module.exports = __webpack_public_path__ + "static/media/PaymentsIcon.9dc0b50d.svg";